import { ReactElement, useContext, useMemo } from 'react';
import { StoresContext } from '../App';

type RenderComponent = (props: {
    country: string;
    region: string;
    city: string;
    countries: string[];
    regions: string[];
    cities: string[];
    setCountry: (v: string) => void;
    setRegion: (v: string) => void;
    setCity: (v: string) => void;
}) => ReactElement;
const compareStrings = (a: string, b: string) => {
    const nameA = a.toLowerCase();
    const nameB = b.toLowerCase();
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
};
export default function LocationFilters({ render }: { render: RenderComponent }) {
    const { allStores, locationFilters, setLocationFilters } = useContext(StoresContext);
    const options = useMemo(() => {
        const countries = new Set<string>();
        const regions = new Set<string>();
        const cities = new Set<string>();
        for (const s of allStores) {
            if (s.country) {
                countries.add(s.country);
            }
            if (locationFilters.country && s.region && s.country === locationFilters.country) {
                regions.add(s.region);
            }
            if (
                locationFilters.country &&
                locationFilters.region &&
                s.city &&
                s.country === locationFilters.country &&
                s.region === locationFilters.region
            ) {
                cities.add(s.city);
            }
        }
        return {
            countries: Array.from(countries).sort(compareStrings),
            regions: Array.from(regions).sort(compareStrings),
            cities: Array.from(cities).sort(compareStrings),
        };
    }, [allStores, locationFilters]);
    const setValues = (v: { country?: string; region?: string; city?: string }) => {
        setLocationFilters((values) => ({ ...values, ...v }));
    };
    const setters = {
        setCountry: (country: string) => {
            setValues({ country, region: '', city: '' });
        },
        setRegion: (region: string) => {
            setValues({ region, city: '' });
        },
        setCity: (city: string) => {
            setValues({ city });
        },
    };
    const Render = render;

    return <Render {...locationFilters} {...options} {...setters} />;
}
